import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import PublicOnlyRoute from 'components/Navigation/PublicOnlyRoute';
import ExternalHeader from 'components/Navigation/ExternalHeader';
import { showErrorToast } from 'components/Toast';

import GeneralApi from 'utils/generalApi';
import { useAuth } from 'contexts/Auth';

const DOCS_FIELD = {
  empresa: 'tyc_pj',
  persona: 'tyc_pn',
  privacidad: 'pp',
};

const DOCS_NAME = {
  empresa: 'Términos y Condiciones',
  persona: 'Términos y Condiciones',
  privacidad: 'Política de Privacidad',
};

export default function DocumentPage() {
  const { documentName } = useParams();
  const history = useNavigate();
  const auth = useAuth();

  const generalApi = useMemo(() => new GeneralApi(auth, history, 'customer'), [auth, history]);

  const [document, setDocument] = useState<any>(null);

  useEffect(() => {
    const getDocument = async () => {
      const result = await generalApi.get(
        `/webinfo/${DOCS_FIELD[documentName as keyof typeof DOCS_FIELD]}`
      );
      if (!result.success) {
        showErrorToast(result.message);
        return;
      }
      setDocument({
        name: DOCS_NAME[documentName as keyof typeof DOCS_NAME],
        url: result.data.info,
      });
    };
    if (documentName) {
      getDocument();
    }
  }, [generalApi, documentName]);

  return (
    <PublicOnlyRoute>
      <div className="min-h-full bg-gray-100">
        <ExternalHeader />
        <h1 className="mt-8 text-center text-4xl">{document?.name}</h1>
        <object
          className="mt-8 h-[70vh] w-full"
          data={`https://drive.google.com/viewerng/viewer?embedded=true&url=${document?.url}`}
          type="application/pdf"
        >
          <embed
            className="w-full"
            src={`https://drive.google.com/viewerng/viewer?embedded=true&url=${document?.url}`}
            type="application/pdf"
          />
          Su navegador no permite mostrar archivos PDF. Por favor descargelo para visualizarlo:
          <a href={`https://drive.google.com/viewerng/viewer?embedded=true&url=${document?.url}`}>
            Descargar PDF
          </a>
        </object>
      </div>
    </PublicOnlyRoute>
  );
}
